export const build = { date:"2026-07-02.1137", stage:"alpha" }
